import {DeliveryMethod} from '~/shared/consts/restaurantConsts';

import {makeReducer} from '../../redux-toolbelt';

import {setCurrentDeliveryMethod} from './currentDeliveryMethodActions';

export type CurrentDeliveryMethodState = DeliveryMethod | null;

export default makeReducer<CurrentDeliveryMethodState, CurrentDeliveryMethodState>(setCurrentDeliveryMethod);
